var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileActiveCourseInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5C6.12109 2.5 5 3.62109 5 5V20C5 21.3789 6.12109 22.5 7.5 22.5H17.5C18.8789 22.5 20 21.3789 20 20V8.75H15C14.3086 8.75 13.75 8.19141 13.75 7.5V2.5H7.5ZM15 2.5V7.5H20L15 2.5ZM9.375 12.5H15.625C15.9687 12.5 16.25 12.7812 16.25 13.125C16.25 13.4688 15.9687 13.75 15.625 13.75H9.375C9.03125 13.75 8.75 13.4688 8.75 13.125C8.75 12.7812 9.03125 12.5 9.375 12.5ZM9.375 15H15.625C15.9687 15 16.25 15.2812 16.25 15.625C16.25 15.9688 15.9687 16.25 15.625 16.25H9.375C9.03125 16.25 8.75 15.9688 8.75 15.625C8.75 15.2812 9.03125 15 9.375 15ZM9.375 17.5H15.625C15.9687 17.5 16.25 17.7812 16.25 18.125C16.25 18.4688 15.9687 18.75 15.625 18.75H9.375C9.03125 18.75 8.75 18.4688 8.75 18.125C8.75 17.7812 9.03125 17.5 9.375 17.5Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileActiveCourseInfo);
export default __webpack_public_path__ + "static/media/FileActive-CourseInfo.8b03af1dc8f67dcba67b4e4995849acc.svg";
export { ForwardRef as ReactComponent };